import React, { useState, useEffect, useCallback } from 'react';

const getToken = () => localStorage.getItem('token');

const DEFAULT_DISPLAY = {
  hide_curator_roles: true,
  hide_period_summary: false,
};

function SettingsToggle({ label, description, checked, onChange }) {
  return (
    <label className="mrp-rating-toggle">
      <input type="checkbox" className="mrp-rating-toggle-input" checked={checked} onChange={onChange} />
      <span className="mrp-rating-toggle-track" aria-hidden="true">
        <span className="mrp-rating-toggle-thumb" />
      </span>
      <span className="mrp-rating-toggle-text">
        <span className="mrp-rating-toggle-label">{label}</span>
        {description ? <span className="mrp-rating-toggle-desc">{description}</span> : null}
      </span>
    </label>
  );
}

export default function SettingsDisplay({ isActive, setError, setSuccess }) {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(() => ({ ...DEFAULT_DISPLAY }));

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/app-settings', {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Не удалось загрузить настройки отображения');
      setForm({
        ...DEFAULT_DISPLAY,
        ...(data.statistics_display && typeof data.statistics_display === 'object'
          ? data.statistics_display
          : {}),
      });
    } catch (e) {
      setError(e.message);
      setTimeout(() => setError(''), 4000);
    } finally {
      setLoading(false);
    }
  }, [setError]);

  useEffect(() => {
    if (isActive) load();
  }, [isActive, load]);

  const setToggle = (key, checked) => {
    setForm((prev) => ({ ...prev, [key]: checked }));
  };

  const save = async (e) => {
    e.preventDefault();
    if (saving) return;
    setSaving(true);
    try {
      const payload = {
        hide_curator_roles: form.hide_curator_roles !== false,
        hide_period_summary: form.hide_period_summary === true,
      };
      const res = await fetch('/api/app-settings/statistics_display', {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${getToken()}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ setting_value: payload }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Не удалось сохранить');
      setForm({
        ...DEFAULT_DISPLAY,
        ...(data.setting_value && typeof data.setting_value === 'object' ? data.setting_value : payload),
      });
      setSuccess('Сохранено');
      setTimeout(() => setSuccess(''), 1800);
    } catch (err) {
      setError(err.message);
      setTimeout(() => setError(''), 4000);
    } finally {
      setSaving(false);
    }
  };

  if (!isActive) return null;
  if (loading) return <div className="loading">Загрузка…</div>;

  return (
    <form className="settings-panel" onSubmit={save}>
      <section className="settings-card">
        <h2 className="settings-card__title">Статистика</h2>
        <div className="settings-rows settings-rows--toggles">
          <SettingsToggle
            label="Скрывать кураторов"
            description="Роли admin, Chief, Deputy не показываются в статистике и выплатах"
            checked={form.hide_curator_roles !== false}
            onChange={(e) => setToggle('hide_curator_roles', e.target.checked)}
          />
          <SettingsToggle
            label="Скрывать итоговую сводку"
            description="Пункт «Итоговая сводка» скрыт в меню"
            checked={form.hide_period_summary === true}
            onChange={(e) => setToggle('hide_period_summary', e.target.checked)}
          />
        </div>
      </section>

      <div className="settings-actions">
        <button type="button" className="settings-btn settings-btn--ghost" onClick={load} disabled={saving}>
          Отменить
        </button>
        <button type="submit" className="settings-btn settings-btn--primary" disabled={saving}>
          {saving ? '…' : 'Сохранить'}
        </button>
      </div>
    </form>
  );
}
